import {Helmet} from "react-helmet-async";
import React, {useEffect, useState} from "react";
import { CssBaseline} from "@mui/material";
import Box from "@mui/material/Box";
import SideMenu from "../widgets/app-wide/side_bar/side_menu";
import SupportTicketsCatalog from "../widgets/support_tickets/support_ticket_catalog";
import FeatureRequestCatalog from "../widgets/feature_requests/feature_request_catalog";
import AccountTestimonial from "../widgets/testimonial/account_testimonial";
import UserLicenseCatalog from "../widgets/license/user_license_catalog";
import SupportUs from "../widgets/dev_support/support_us";
import UserSettings from "../widgets/settings/user_settings";
import BuildCompatibilityCatalog from "../widgets/build/build_compatibility_catalog";

export default function AccountPage() {
    const [hash, setHash] = useState(window.location.hash);

    useEffect(() => {
        const handleHashChange = () => {
            setHash(window.location.hash);
        };

        // listen for hash changes
        window.addEventListener('hashchange', handleHashChange);

        // cleanup the event listener
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        }
    });

    const content = () => {
        switch (hash) {
            case "#settings":
                return <UserSettings/>
            case "#licenses":
                return <UserLicenseCatalog/>
            case "#feature-request":
                return <FeatureRequestCatalog/>
            case "#review":
                return <AccountTestimonial/>
            case "#download":
                return <BuildCompatibilityCatalog/>
            case "#request-support":
                return <SupportTicketsCatalog/>
            case "#support":
                return <SupportUs/>
            default:
                return <UserSettings/>
        }
    };

    return (
        <div>
            <Helmet title={"PennyPusher | Admin"}/>

            <div>
                <CssBaseline enableColorScheme />
                <Box sx={{ display: 'flex' }}>
                    <SideMenu />
                    <Box component="main" sx={(theme) => ({flexGrow: 1,
                        backgroundColor: `rgba(${theme.palette.background} / 1)`,
                        overflow: 'auto'})}>

                        <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
                            {content()}
                        </Box>
                    </Box>
                </Box>
            </div>
        </div>
    );
}